import { ExpressionValidationResultDc } from "@evergis/api";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { setValidationServerError } from "../ducks/validation/validation";
import { getValidationServerError } from "../ducks/validation/selectors";

export const useValidationServerError = () => {
  const dispatch = useDispatch();
  const error = useSelector(getValidationServerError);

  const setError = useCallback(
    (err?: ExpressionValidationResultDc | null) => {
      dispatch(setValidationServerError(err));
    },
    [dispatch],
  );

  return { error, setError } as const;
};
